module.exports = __webpack_public_path__ + "img/asso.1eb2fd81.gif";